module.exports = __webpack_public_path__ + "marker.png?b7387e40aef4da94b18efe808ad2b43d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/marker.png
// module id = 1358
// module chunks = 0